import CountryList from "./CountryList";
import LanguageList from "./LanguageList";
import { useState } from "react";

const CountryLanguage = () => {
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
  const [mobileCountryDropdownOpen, setMobileCountryDropdownOpen] = useState(false);

  return (
    <>
      <div className=" display-max">
        <div className=" mt-4 mb-4 px-2">
          <b className="fs-4 fw-normal text-black">Choose Country</b>
        </div>
        <div className=" w-50 px-2 mb-4">
          <div
            className=" input-group input-group-outline dropdown"
            id="dropdownCountriesDesktop"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            onClick={() => setCountryDropdownOpen(true)}
          >
            <input
              type="text"
              className=" form-control"
              placeholder="Select Country"
            />
            <div>
              <span className=" input-group-text p-1 me-1">
                |
                <i className="ri-arrow-down-s-line fs-3 mt-1 mx-1 cursor-pointer"></i>
              </span>
            </div>
          </div>
          <div
            className="dropdown-menu dropdown-menu-animation shadow-dark dropdown-md nav-menu p-2 px-3 border-radius-2xl"
            aria-labelledby="dropdownCountries"
          >
            <CountryList enabled={countryDropdownOpen} />
          </div>
        </div>
        <div className=" d-flex row justify-content-start align-items-center px-2">
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">English</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">
                    United States
                  </b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">English</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">
                    United Kingdom
                  </b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2 ">
            <a href=".">
              <div className="ms-3">
                <b className=" fw-normal text-black text-md">Dansk</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">Danmark</b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2 ">
            <a href=".">
              <div className="ms-3">
                <b className=" fw-normal text-black text-md">Deutsch</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">
                    Deutschland
                  </b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2 ">
            <a href=".">
              <div className="ms-3">
                <b className=" fw-normal text-black text-md">Deutsch</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">Österreich</b>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className=" mt-4 mb-4 px-2">
          <b className="fs-4 fw-normal text-black">Choose Language</b>
        </div>
        <div className=" w-50 px-2 mb-4">
          <div
            className=" input-group input-group-outline dropdown"
            id="dropdownCountries"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <input
              type="text"
              className=" form-control"
              placeholder="Select Language"
            />
            <div>
              <span className=" input-group-text p-1 me-1">
                |
                <i className="ri-arrow-down-s-line fs-3 mt-1 mx-1 cursor-pointer"></i>
              </span>
            </div>
          </div>
          <div
            className="dropdown-menu dropdown-menu-animation shadow-dark dropdown-md nav-menu p-2 px-3 border-radius-2xl"
            aria-labelledby="dropdownCountries"
          >
             <LanguageList />
          </div>
        </div>
        <div className=" d-flex row justify-content-start align-items-center px-2">
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">English</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">
                    United States
                  </b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">English</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">
                    United Kingdom
                  </b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">हिन्दी</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">भारत</b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">ಕನ್ನಡ</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">ಭಾರತ</b>
                </div>
              </div>
            </a>
          </div>
          <div className=" lh-base col language p-2">
            <a href=".">
              <div className=" ms-3">
                <b className=" fw-normal text-black text-md">मराठी</b>
                <div>
                  <b className=" fw-normal text-black-50 text-sm">भारत</b>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className=" display-mini display-mob">
        <div className=" mt-3 px-2 p-2 px-2">
          <b className="fs-5 fw-bold text-black">Select Country</b>
        </div>
        <div className=" w-100 px-2 mb-2">
          <div
            className=" input-group input-group-outline dropdown"
            id="dropdownCountriesMobile"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            onClick={() => setMobileCountryDropdownOpen(true)}
          >
            <input
              type="text"
              className=" form-control"
              placeholder="Select Country"
            />
            <div>
              <span className=" input-group-text p-1 me-1">
                |
                <i className="ri-arrow-down-s-line fs-3 mt-1 mx-1 cursor-pointer"></i>
              </span>
            </div>
          </div>
          <div
            className="dropdown-menu dropdown-menu-animation shadow-dark dropdown-lg nav-menu p-2 px-3 border-radius-2xl"
            aria-labelledby="dropdownCountries"
          >
            <CountryList enabled={mobileCountryDropdownOpen} />
          </div>
        </div>
        <hr className=" horizontal dark mt-3 mb-3" />
        <div className=" mt-3 px-2">
          <b className="fs-6 fw-bold text-black">Select Language</b>
        </div>
        <div className=" w-100 px-2 mb-4">
          <div
            className=" input-group input-group-outline dropdown"
            id="dropdownCountries"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <input
              type="text"
              className=" form-control"
              placeholder="Select Language"
            />
            <div>
              <span className=" input-group-text p-1 me-1">
                |
                <i className="ri-arrow-down-s-line fs-3 mt-1 mx-1 cursor-pointer"></i>
              </span>
            </div>
          </div>
          <div
            className="dropdown-menu dropdown-menu-animation shadow-dark dropdown-lg nav-menu p-2 px-3 border-radius-2xl"
            aria-labelledby="dropdownCountries"
          >
            <LanguageList />
          </div>
        </div>
      </div>
    </>
  );
};

export default CountryLanguage;
